import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CurrencyProvider } from './context/CurrencyContext';
import { AuthProvider } from './context/AuthContext';
import { BrandProvider } from './context/BrandContext';
import Landing from './pages/Landing';
import PricingEstimator from './pages/PricingEstimator';
import CorePricing from './pages/CorePricing';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import ProductRoute from './components/ProductRoute';
import AdminLayout from './components/AdminLayout';
import AdminOverview from './pages/admin/AdminOverview';
import UsersPage from './pages/admin/UsersPage';
import RegionsPage from './pages/admin/RegionsPage';
import CustomersPage from './pages/admin/CustomersPage';
import PriceListsPage from './pages/admin/PriceListsPage';
import QuoteBuilder from './pages/admin/QuoteBuilder';
import QuotesListPage from './pages/admin/QuotesListPage';
import QuoteDetailPage from './pages/admin/QuoteDetailPage';
import SettingsPage from './pages/admin/SettingsPage';
import PublicQuote from './pages/PublicQuote';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandProvider>
          <CurrencyProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/streamline" element={<ProductRoute product="streamline"><PricingEstimator /></ProductRoute>} />
                <Route path="/pti" element={<ProductRoute product="pti"><PricingEstimator /></ProductRoute>} />
                <Route path="/itanta" element={<ProductRoute product="pti"><PricingEstimator /></ProductRoute>} />
                <Route path="/core" element={<ProductRoute product="core"><CorePricing /></ProductRoute>} />
                <Route path="/login" element={<Login />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/quote/:id" element={<PublicQuote />} />

                <Route path="/admin" element={
                  <ProtectedRoute adminOnly>
                    <AdminLayout />
                  </ProtectedRoute>
                }>
                  <Route index element={<AdminOverview />} />
                  <Route path="quotes" element={<QuotesListPage />} />
                  <Route path="quotes/new" element={<QuoteBuilder />} />
                  <Route path="quotes/:id" element={<QuoteDetailPage />} />
                  <Route path="price-lists" element={<PriceListsPage />} />
                  <Route path="customers" element={<CustomersPage />} />
                  <Route path="regions" element={<RegionsPage />} />
                  <Route path="users" element={<ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>} />
                  <Route path="settings" element={<ProtectedRoute adminOnly><SettingsPage /></ProtectedRoute>} />
                </Route>
              </Routes>
            </BrowserRouter>
          </CurrencyProvider>
        </BrandProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
